import { IReturn } from "@/interfaces/Return";
import { formateDate } from "@/utils/date-utils";
import { cn } from "@/lib/utils";
import React from "react";

interface ReturnHeaderProps {
  return_: IReturn;
  showDemandeAndDate?: boolean;
}

const ReturnHeader: React.FC<ReturnHeaderProps> = ({
  return_,
  showDemandeAndDate = false,
}) => {
  return (
    <div
      className={cn(
        "flex flex-col gap-4",
        showDemandeAndDate
          ? "mx-4 rounded-lg border-2 border-gray-300 bg-muted/20 p-4"
          : "px-4 py-4"
      )}
    >
      <div className="flex items-start justify-between gap-2 flex-row">
        <div className="space-y-1">
          <p className="text-md text-muted-foreground">N° de retour</p>
          <p className="font-semibold">
            {return_.numTournee && return_.numTournee}
          </p>
        </div>
        <div className="space-y-1 text-right">
          <p className="text-md text-muted-foreground">Vendeur</p>
          <p className="font-semibold">
            {return_.sellerName && return_.sellerName}
          </p>
        </div>
      </div>
      {showDemandeAndDate && (
        <div className="flex items-start justify-between gap-2 flex-row">
          {return_.numDemande != null && (
            <div className="space-y-1">
              <p className="text-md text-muted-foreground">N° de demande</p>
              <p className="font-semibold">{return_.numDemande}</p>
            </div>
          )}
          <div className="space-y-1 text-right ml-auto">
            <p className="text-md text-muted-foreground">Date</p>
            <p className="font-semibold">{formateDate(return_.createdon)}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReturnHeader;
